export enum SELECTOR_TYPE {
    MONTH,
    YEAR,
    DEPARTURE
}

export enum MONTH_DIRECTION {
    FORWARD,
    BACK
}

export const AVAILABILITY_CALENDAR = {
    CLASS_NAME: 'Availability Calendar',
    TRAVEL_DAY: 'travel-day',
    AVAILABLE: 'available-departure',
    NOT_AVAILABLE: 'not-available',
    AVAILABLE_SELECTED: 'available-selected',
    LIMITED_AVAILABILITY: 'limited-availability',
    SCHEDULE: 'schedule',
    AVAIL: 'avail',
    FORMAT_LONG: 'long',
    FORMAT_SHORT: 'short',
    SELECTED: 'selected',
    REQUEST_NUMBER_OF_MONTHS: 10,
    DESKTOP_DISPLAY_NUMBER_OF_MONTHS: 3,
    MOBILE_DISPLAY_NUMBER_OF_MONTHS: 1,
    CHANGE_BY_NUMBER_OF_MONTHS: 1,
    CALENDAR_DATE: 'date-',
    DATA_DATE: 'data-date',
    ALL: 'all',
    FADE_OUT: 'fade-out',
    FADE_IN: 'fade-in',
};

export const AVAIL_CALENDAR_ANALYTICS = {
    DATE_SELECTED: 'Avail_CheckInDate_Selected',
    DROPDOWN_SELECTION: 'Avail_Filter',
    NEXT_AVAIL: 'Next_Avail_Interaction',
    CALENDAR_FORWARD: 'Calendar_AdvanceCarousel',
    CALENDAR_RETREAT: 'Calendar_RetreatCarousel',
    CALENDAR_START: 'GscStart',
    DATE_FORMAT: 'MM/DD/YYYY'
};
